import React from 'react';
import { ChipCellRendererProps } from 'src/components/AgGrid/Renderer/types';
import { BaseChip } from 'src/components/UI';
import StringUtils from 'src/utils/StringUtils';

export const ChipCellRenderer: React.FC<ChipCellRendererProps> = React.memo(
  ({ mapStatusToSeverity, value }) => (
    <BaseChip
      severity={mapStatusToSeverity(value)}
      label={StringUtils.ConvertTitleCase(value)}
    />
  ),
);
